// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"2cf046ce","193":"c89140ce","253":"52092e41","262":"fcd7dd9c","598":"28743a0a","725":"4c8ed1a8","774":"78fd45fd","787":"2fc93668","850":"d0d71de7"}[chunkId] + ".chunk.js";
};